const {KitModule, registerModule} = globalThis;

class DeFiChart extends KitModule {
  constructor($element) {
    super($element);

    this.$downloadButtons = Array.from(
      this.$element.querySelectorAll('[data-js-child="$downloadBtn"]'),
    );

    this.$downloadButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => this.handleDownload(e));
    });

    this.formatDate();
  }

  formatDate() {
    const $date = this.$element.querySelector('[data-js-child="$date"]');
    if (!$date) return;

    const isoDate = $date.dataset.date;
    const date = new Date(isoDate);
    const formatted = date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short',
    });

    $date.textContent = `As of ${formatted}`;
  }

  async handleDownload(e) {
    const btn = e.currentTarget;
    const symbol = btn.dataset.symbol;

    try {
      const response = await fetch(process.env.DEFI_RATES_HISTORY_URL, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          symbol,
          days: 30,
          format: 'csv',
        }),
      });

      if (!response.ok) {
        throw new Error(`Download failed: ${response.statusText}`);
      }
      const disposition = response.headers.get('Content-Disposition');
      const filenameRegex = /filename="?([^";\n]+)"?/;
      const filename = disposition ? filenameRegex.exec(disposition)?.[1] || `${symbol}-rates.csv` : `${symbol}-rates.csv`;

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error(`Failed to download rates for ${symbol}:`, err);
    }
  }
}

registerModule('DeFiChart', DeFiChart);
